import { useCallback, useEffect, useState } from "react"

import { Modal } from "antd"
import { useDispatch, useSelector } from "react-redux"

import { DashboardFiltersBlock } from "../../../../../Components/Filters/DashboardFiltersBlock/DashboardFiltersBlock"
import Icon from "../../../../../Icon"
import { configureDate, serializeData } from "../../../../../Utils/utils"
import AlertsOverviewChart from "../../../../DashboardPage/components/AlertsOverviewChart"
import { getAlertsByBusinessAccountId } from "../../../redux/referrals.thunks"

const AlertsModal = ({ isOpen, baId, closeModal }) => {
  const [selectPeriod, setSelectPeriod] = useState({ period: "7 days" })
  const dispatch = useDispatch()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { baAlerts, baAlertsFetching } = useSelector((state) => state.referrals)

  const handleChangeFilter = useCallback(
    (newFilters) => {
      if (Array.isArray(newFilters.period)) {
        setSelectPeriod({
          __preset_period: newFilters?.__preset_period,
          period: { type: "custom", period: newFilters.period }
        })
      } else {
        setSelectPeriod(newFilters)
      }
    },
    [baId]
  )

  useEffect(() => {
    if (isOpen && baId) {
      const dates =
        selectPeriod.period?.type === "custom"
          ? configureDate("custom", selectPeriod.period.period)
          : configureDate(selectPeriod.period)
      const serializeFilters = serializeData(dates)
      dispatch(
        getAlertsByBusinessAccountId({
          business_id: baId,
          ...serializeFilters
        })
      )
    }
  }, [selectPeriod, baId, isOpen])

  return (
    <Modal
      open={isOpen}
      centered={!isMobile}
      width={isMobile ? "100%" : "80%"}
      title={`Alerts sent: ${baAlerts?.total_value ?? 0}`}
      footer={null}
      closable="true"
      onCancel={closeModal}
      destroyOnClose
      closeIcon={<Icon type="cross_small" />}
      classNames={{ content: "clear-bg" }}
      wrapClassName={isMobile ? "alerts-modal--mobile" : ""}
      getContainer={isMobile ? document.body : () => document.getElementById("global-wrap")}
    >
      <div className="date-filter">
        <DashboardFiltersBlock
          handleChangeFilter={handleChangeFilter}
          filters={selectPeriod}
          onlyPeriod
        />
      </div>
      <div style={{ marginTop: 40, minHeight: isMobile ? 220 : undefined }}>
        {baAlerts && <AlertsOverviewChart data={baAlerts?.chart} isFetching={baAlertsFetching} />}
      </div>
    </Modal>
  )
}

export default AlertsModal
